var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-app"},[(_vm.loggedInApplicant)?_c('applicant-header-section'):_vm._e(),(_vm.loggedInApplicant)?_c('applicant-sidebar-section'):_vm._e(),_c('div',{attrs:{"id":"maincontent"}},[(_vm.loggedInApplicant)?_c('MandatoryDetails'):_vm._e(),_c('router-view')],1),_c('footer-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }